import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import Login from './auth/login/Login';
import Pacientes from './pacientes/Pacientes';
import Sucursales from './sucursales/sucursales';
import Usuarios from './usuarios/usuarios';
import TiposUsuarios from './tiposUsuarios/tiposUsuarios';
import Empresas from './empresas/Empresas';
import OptometriaNeonatos from './consultas/optometria_neonatos/Optometria_neonatos'
import Servicios_clinicos from './servicios_clinicos/Servicios_clinicos';
import Chat from './chat/Chat';
import Conversaciones from './chat/conversaciones/Conversaciones';
import Profile from './profile/profile';
import emailVerification from './profile/emailVerification';
import citas from './citas/citas';

const createRootReducer = (history: any) => combineReducers({
  router: connectRouter(history),
  login: Login,
  pacientes:Pacientes,
  sucursales: Sucursales,
  usuarios: Usuarios,
  tiposUsuarios: TiposUsuarios,
  empresas: Empresas,
  optometriaNeonatos: OptometriaNeonatos,
  servicios_clinicos: Servicios_clinicos,
  chat: Chat,
  conversaciones: Conversaciones,
  profile: Profile,
  emailVerification: emailVerification,
  citas: citas
});

export default createRootReducer;